// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0cba4d2d","488":"230a3122","732":"8032b933","977":"7e87bf26"}[chunkId] + ".chunk.js";
};